// extracted by mini-css-extract-plugin
export default {"card":"Card_card__CtUL6","hover":"Card_hover__GdsFk","header":"Card_header__QT818","title":"Card_title__QHhlF","action":"Card_action__Owf3o","content":"Card_content__WCKkv"};